var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"structure-binary-tabs"},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.id,staticClass:"structure-binary-tabs__item",class:{
      'structure-binary-tabs__item_selected': _vm.selectedTab.id === tab.id,
    },on:{"click":function($event){return _vm.$emit('update:selectedTab', tab)}}},[_c('span',{staticClass:"structure-binary-tabs__icon",class:tab.icon}),_c('p',[_vm._v(_vm._s(tab.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }